import { Modal, styled } from '@mui/material';
import { Box } from '@mui/system';
import { WsColors } from 'wisestep-base';

import AppsMenu from '../AppsMenu/AppsMenu';

const AppsMenuBox = styled(Box)({
  position: 'absolute' as const,
  top: 60,
  right: 48,
});

type AppsMenuModalPropsType = {
  open: boolean;
  handleClose: () => void;
};

const AppsMenuModal = ({ open, handleClose }: AppsMenuModalPropsType) => (
  <Modal open={open} onClose={handleClose}>
    <AppsMenuBox borderRadius={1.5} bgcolor={WsColors.TertiaryShades100} p={2} width={816}>
      <AppsMenu />
    </AppsMenuBox>
  </Modal>
);

export default AppsMenuModal;
